import queryString from 'query-string';

import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { ApiVolopFunction } from 'api/types/ApiVolopFunction';
import { Box } from 'components/Box';
import { CmsAmpCardsBlockCard } from 'modules/cms/blocks/Amp/Cards';
import { gutterWidth } from 'theme/theme';
import { objectEmpty } from 'utils/functional';

export function CmsAmpRecommendedActionsBlockActions({
  volopFunction,
  areaOfFocus,
  locale,
}: {
  volopFunction: ApiVolopFunction | null | undefined;
  areaOfFocus: ApiAreaOfFocus | null | undefined;
  locale: UserLocale | 'all';
}) {
  const queryParams: Record<string, string> = {};
  if (volopFunction) {
    queryParams.functions = volopFunction;
  }
  if (areaOfFocus) {
    queryParams.areasOfFocus = areaOfFocus;
  }
  if (locale !== 'all') {
    queryParams.locale = locale;
  }
  let qs = '';
  if (!objectEmpty(queryParams)) {
    qs = `?${queryString.stringify(queryParams)}`;
  }
  return (
    <amp-list
      width="auto"
      height="100"
      layout="fixed-height"
      src={`/data/website/search/latest-action${qs}`}
      items="results"
      max-items="3"
    >
      <template type="amp-mustache">
        <Box
          // @ts-expect-error TS(2695): Left side of comma operator is unused and has no s... Remove this comment to see the full error message
          display={('block', null, 'inline-block')}
          width={[1, null, 1 / 3]}
          verticalAlign="top"
          maxWidth={320}
          px={[0, null, gutterWidth / 2]}
          py={[gutterWidth / 2, null, 0]}
        >
          <CmsAmpCardsBlockCard
            card={{
              image: {
                filename: '{{logo.filename}}',
                handle: '{{logo.handle}}',
                mimetype: '{{logo.mimetype}}',
                size: parseInt('{{logo.size}}', 10),
                source: '{{logo.source}}',
              },
              headline: '{{name}}',
              text: '{{addressText}}',
              label: '{{orgName}}',
              urls: {
                en: '{{url.en}}',
                es: '{{url.es}}',
                pt: '{{url.pt}}',
              },
            }}
            imageSize="SMALL"
          />
        </Box>
      </template>
    </amp-list>
  );
}
